import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog";
import { Progress } from "@/components/ui/progress";
import { Loader2 } from "lucide-react";

interface Props {
	isOpen: boolean;
	totalSteps: number;
	completedSteps: number;
	isRemoving: boolean;
}

/**
 * A dialog showing progress of bulk assignment operations
 * @param props.isOpen - Whether the dialog is open
 * @param props.totalSteps - Total number of steps to process
 * @param props.completedSteps - Number of completed steps
 * @param props.isRemoving - Whether this is a removal operation
 */
export function BulkAssignmentProgressDialog({
	isOpen,
	totalSteps,
	completedSteps,
	isRemoving,
}: Props) {
	const percentage =
		totalSteps > 0 ? Math.round((completedSteps / totalSteps) * 100) : 0;

	return (
		<Dialog open={isOpen}>
			<DialogContent
				className="sm:max-w-[400px] bg-background-secondary"
				onPointerDownOutside={(e) => e.preventDefault()}
				onInteractOutside={(e) => e.preventDefault()}
			>
				<DialogHeader>
					<DialogTitle className="flex items-center gap-2">
						<Loader2 className="h-5 w-5 animate-spin text-primary" />
						{isRemoving
							? "Zuweisungen werden entfernt..."
							: "Zuweisungen werden vorgenommen..."}
					</DialogTitle>
					<DialogDescription asChild>
						<div className="space-y-4 pt-4">
							<div className="space-y-2">
								<div className="flex justify-between text-sm">
									<span className="text-muted-foreground">Fortschritt:</span>
									<span className="font-medium">
										{completedSteps} / {totalSteps}
									</span>
								</div>
								<Progress value={percentage} className="h-2" />
								<p className="text-xs text-center text-muted-foreground">
									{percentage}% abgeschlossen
								</p>
							</div>
							<p className="text-sm text-muted-foreground">
								Bitte warten Sie, während die Zuweisungen verarbeitet werden.
								Dies kann bei vielen Zuweisungen einige Minuten dauern.
							</p>
						</div>
					</DialogDescription>
				</DialogHeader>
			</DialogContent>
		</Dialog>
	);
}
